export default __webpack_public_path__ + "static/media/wellbeing-red.1b9ec326.svg";